import { ColDef } from 'ag-grid-community';
import { CheckboxCellRendererComponent } from './checkbox-cell-renderer/checkbox-cell-renderer.component';
import { ContentMobileCellRendererComponent } from './content-mobile-cell-renderer/content-mobile-cell-renderer.component';
import { EditMemberDialogComponent } from './edit-member-dialog/edit-member-dialog.component';
import { HeaderCheckboxCellRendererComponent } from './header-checkbox-cell-renderer/header-checkbox-cell-renderer.component';
import { InviteLinkCellRendererComponent } from './invite-link-cell-renderer/invite-link-cell-renderer.component';
import { InviteLinkHeaderRendererComponent } from './invite-link-header-renderer/invite-link-header-renderer.component';

export interface AgGridObject {
  id: number;
  teamMemberId: string;
  firstName: string;
  lastName: string;
  fullName: string;
  emailAddress: string;
  status: string;
  accessCode: string;
  selected: boolean;
  isTeamLeader: boolean;
}

export const columnDefinitions = {
  columnsDesktop: [
    { headerName: '', field: 'teamMemberId', hide: true },
    { headerName: '', field: 'firstName', hide: true },
    { headerName: '', field: 'lastName', hide: true },
    {
      headerName: '',
      field: 'id',
      maxWidth: 60,
      cellRenderer: (params) => {
        return params.node.rowIndex + 1 + '.'; // Ids start at 0 but grid should start at 1
      },
    },
    {
      field: 'checkbox',
      width: 50,
      maxWidth: 50,
      autoHeight: false,
      cellRenderer: CheckboxCellRendererComponent,
      headerComponent: HeaderCheckboxCellRendererComponent,
    },
    {
      headerName: 'Name',
      autoHeight: false,
      sortable: true,
      unSortIcon: true,
      field: 'fullName',
      filter: 'agTextColumnFilter',
      // getQuickFilterText: (params) => {
      //   return `${params.data.firstName} ${params.data.lastName}`.toLowerCase().replace(/ /g, '');
      // },
      valueFormatter: (params) => {
        if (params.data.isTeamLeader) {
          return params.data.fullName + ' (You)';
        } else {
          return params.data.fullName;
        }
      },
    },
    {
      maxWidth: 50,
      autoHeight: false,
      sortable: false,
      resizable: false,
      cellStyle: { 'text-overflow': 'unset' },
      cellRenderer: EditMemberDialogComponent,
    },
    {
      headerName: 'Email Address',
      autoHeight: false,
      field: 'emailAddress',
      sortable: true,
      unSortIcon: true,
    },
    {
      maxWidth: 150,
      autoHeight: false,
      headerName: 'Status',
      field: 'status',
      sortable: true,
      unSortIcon: true,
      cellClassRules: {
        completed: (params) => {
          return params.value === 'Completed';
        },
        'in-progress': (params) => {
          return params.value === 'In Progress';
        },
        'not-started': (params) => {
          return params.value === 'Not Started';
        },
      },
      getQuickFilterText: () => '',
    },
    {
      maxWidth: 150,
      autoHeight: false,
      headerName: 'First Invite',
      field: 'inviteDate',
      sortable: true,
      unSortIcon: true,
      getQuickFilterText: () => '',
      valueFormatter: (params) => new Date(params.value).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
    },
    {
      maxWidth: 150,
      autoHeight: false,
      sortable: false,
      headerComponent: InviteLinkHeaderRendererComponent,
      headerClass: 'ag-header-cell-text',

      unSortIcon: false,
      cellRenderer: InviteLinkCellRendererComponent,
    },
  ] as ColDef[],

  columnsMobile: [
    { headerName: '', field: 'teamMemberId', hide: true },
    { headerName: '', field: 'firstName', hide: true },
    { headerName: '', field: 'lastName', hide: true },
    { headerName: '', field: 'emailAddress', hide: true },
    {
      field: 'checkbox',
      maxWidth: 50,
      width: 50,
      cellRenderer: CheckboxCellRendererComponent,
      headerComponent: HeaderCheckboxCellRendererComponent,
    },
    {
      headerName: 'NAME, EMAIL AND ACCESS CODE',
      sortable: true,
      unSortIcon: true,
      cellRenderer: ContentMobileCellRendererComponent,
    },
    {
      headerName: 'Status',
      field: 'status',
      maxWidth: 130,
      sortable: true,
      unSortIcon: true,
      cellClassRules: {
        completed: (params) => {
          return params.value === 'Completed';
        },
        'in-progress': (params) => {
          return params.value === 'In Progress';
        },
        'not-started': (params) => {
          return params.value === 'Not Started';
        },
      },
      getQuickFilterText: () => '',
    },
  ] as ColDef[],
};
